import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import Header from "../../../src/component/Header";
import IconDelete from "../../../src/component/SvgIcons/IconDelete";
import IconPen from "../../../src/component/SvgIcons/IconPen";
import IconPlus from "../../../src/component/SvgIcons/IconPlus";
import IconUpdownFilter from "../../../src/component/SvgIcons/IconUpdownFilter";
import Pagination from "../../component/Pagination";
import IconSearch from "../../component/SvgIcons/IconSearch";
import api from "../../Services/api"; // Axios instance
import { formatCountryDate } from "../../Services/countryTime";

export default function Careers() {
  const [careers, setCareers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);  

    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth >= 1920) {
          setItemsPerPage(20);
        } else {
          setItemsPerPage(10);
        }
      };
      handleResize(); // Set initial value
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  useEffect(() => {
    fetchCareers();
  }, []);

  // Fetch Careers from API
  const fetchCareers = async () => {
    try {
      const response = await api.post("/ViewCareer");
      const careerData = response.data.reverse();
      setCareers(careerData);
    } catch (error) {
      console.error("Error fetching careers:", error);
    }
  };

  // Handle Search
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  // Handle Sorting
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedCareers = [...careers].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // Filter Careers
  const filteredCareers = sortedCareers.filter((career) => {
    const formattedDate = formatCountryDate(career.DateTime)
      .replace(/\//g, "-");  
    return (
      formattedDate.includes(searchQuery) ||
      career.heading.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.content.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCareers = filteredCareers.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredCareers.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle Delete Career
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to remove this job post?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      await api.post(`/deleteCareer/${id}`);
      setCareers(careers.filter((career) => career.id !== id));
      Swal.fire("Deleted!", "Career deleted successfully.", "success");
    } catch (error) {
      console.error("Error deleting career:", error);
      Swal.fire("Error", "Failed to delete career.", "error");
    }
  };
  return (
    <section className="eventpage">
      <Header pageTitle="Career Job Post List" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link to="/add-career" className="btn btn-purpal addbutton">
              <IconPlus /> Add New Job Post
            </Link>
            <Link
              to="#"
              onClick={() => handleSort("heading")}             
            >
              <IconUpdownFilter />
            </Link>
          </div>

          <div className="input-container">
            <input
              type="text"
              id="search"
              placeholder="Search Here.."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {/* <label htmlFor="password">Search here..</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>

        <div className="tableheader d-flex flex-column gap-4">
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                <th width="10px" align="center">Sr. No.</th>
                <th>
                  Date
                  </th>
                  <th>
                  Job Title                    
                  </th>
                  <th>
                  Job Details
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentCareers.length > 0 ? (
                  currentCareers.map((career, index) => (
                    <tr key={career.id}>
                      <td align="center">{index + 1}</td>
                      <td> {formatCountryDate(career.DateTime).replace(/\//g, "-")}</td>
                      <td>{career.heading}</td>
                      <td
                        data-tooltip-id={`blog-tooltip-${career.id}`}
                        data-tooltip-content={
                          career.content
                            ? career.content.replace(/<\/?[^>]+(>|$)/g, "")
                            : ""
                        }
                      >
                        {career.content
                          ? career.content.replace(/<\/?[^>]+(>|$)/g, "")
                              .length > 20
                            ? `${career.content
                                .replace(/<\/?[^>]+(>|$)/g, "")
                                .substring(0, 80)}...`
                            : career.content.replace(/<\/?[^>]+(>|$)/g, "")
                          : ""}

                        <Tooltip
                          id={`blog-tooltip-${career.id}`}
                          place="top"
                          effect="solid"
                          style={{
                            whiteSpace: "normal",
                            maxWidth: "600px",
                            zIndex: 9999,
                          }}
                        />
                      </td>

                      {/* <td>{career.content}</td> */}
                      <td>
                        <div className="action">
                          <Link
                            to={`/edit-career/${career.id}`}
                            className="editbtn"
                            data-tooltip-id={`edit-${career.id}`}
                            data-tooltip-content="Edit"
                          >
                            <IconPen />
                          </Link>
                            <Tooltip id={`edit-${career.id}`} place="top"/>

                          <Link to="#" onClick={() => handleDelete(career.id)}
                            data-tooltip-id={`delete-${career.id}`}
                            data-tooltip-content="Delete"
                            >
                            <IconDelete />
                          </Link>
                           <Tooltip id={`delete-${career.id}`} place="top" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
         
          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={filteredCareers.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
